const { InnerBlocks } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { idTab } = attributes;

  return (
    <div className={`TabsCompany__container`} id={idTab}>
      <InnerBlocks.Content />
    </div>
  );
};

export default Save;
